// One field value in a history entry, the ONE place that decides how an old and a new
// value look. The new value is bold and the old one is not, so what changed is what stands
// out (TICKET-23110, Alpine Air Alaska: legacy's change history bolds everything, "it makes
// it rather confusing to tell what's actually changed"). Both history surfaces render it:
// every record History tab (RecordHistoryTab, Old → New) and the audit journal's entry
// modal (History.tsx, Field · Old · New).
export interface HistoryValueProps {
  /** The value as the route served it; null / undefined / "" read as an em dash. */
  value: string | null | undefined;
  /** The value the field changed TO: bold. The old value is plain. */
  changed?: boolean;
  /** Cut a longer value at this many characters, its full text the tooltip. A row in a
   *  History tab is cut (RecordHistoryTab's HISTORY_VALUE_MAX); a modal with room for it shows it whole. */
  maxLength?: number;
  testId?: string;
}

export function HistoryValue({ value, changed = false, maxLength, testId }: HistoryValueProps) {
  const text = value ?? "";
  const long = maxLength != null && text.length > maxLength;
  const shown = text === "" ? "—" : long ? `${text.slice(0, maxLength)}…` : text;
  const Tag = changed ? "strong" : "span";
  return (
    <Tag data-testid={testId} title={long ? text : undefined}>
      {shown}
    </Tag>
  );
}
